<script lang="ts">
  import { t } from '$lib/lang/i18n';
  import { title } from '$lib/global';
  import Section from '$lib/components/generic/Section.svelte';
  import Button from '$lib/components/controls/Button.svelte';
  import { plBricks, productLogo } from '$lib/icons';

  $title = $t('nav.products');
</script>

{#each [
  { product: 'bricks', title: $t('products.bricks.title'), subtitle: $t('products.bricks.subtitle'), body: $t('products.bricks.body'), icon: plBricks, stage: 'beta' },
  { product: 'courier', title: $t('products.courier.title'), subtitle: $t('products.courier.subtitle'), body: $t('products.courier.body'), icon: productLogo.courier, stage: 'beta' },
  { product: 'ingress', title: $t('products.ingress.title'), subtitle: $t('products.ingress.subtitle'), body: $t('products.ingress.body'), icon: productLogo.ingress, stage: 'beta' },
  { product: 'tunnel', title: $t('products.tunnel.title'), subtitle: $t('products.tunnel.subtitle'), body: $t('products.tunnel.body'), icon: productLogo.tunnel, stage: 'beta' },
  { product: 'verify', title: $t('products.verify.title'), subtitle: $t('products.verify.subtitle'), body: $t('products.verify.body'), icon: productLogo.verify, stage: 'beta' }
] as { product, title, subtitle, body, icon, stage }, i (product)}
  {@const even = i % 2 === 0}
  <Section {title} {subtitle} subtitlePosition="after" {body} {icon} iconType="product" layout={even ? 'right' : 'left'} bgColor={even ? 'alternative' : 'normal'}>
    {#if stage === 'beta'}
      <Button
        href="/products/beta/{product}"
        label={$t('products.beta.register.title')}
        style="invert"
      />
    {/if}
  </Section>
{/each}
